<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">通话成功率-详细</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="4">
        <el-select
          style="width: 220px"
          v-model="channel"
          multiple
          placeholder="请选择渠道"
          collapse-tags
          @change="channelChange"
        >
          <el-option
            v-for="(item, itemIndex) in channelsList"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>

      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="mode"
          placeholder=""
        >
          <el-option label="all" value="all"></el-option>
          <el-option label="live模式 否" :value="0"></el-option>
          <el-option label="live模式 是" :value="1"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        height="70vh"
        stripe
        border
      >
        <el-table-column prop="channel" fixed label="渠道" width="200">
        </el-table-column>
        <el-table-column prop="country" label="国家" width="200">
        </el-table-column>
        <el-table-column prop="callCount" label="拨打人数" width="200">
        </el-table-column
        ><el-table-column prop="requestCount" label="通话请求数" width="200">
        </el-table-column
        ><el-table-column prop="totalCount" label="通话扣费数" width="200">
        </el-table-column
        ><el-table-column prop="degree1" label="请求阶段数量" width="200">
        </el-table-column
        ><el-table-column prop="degree2" label="呼叫阶段数量" width="200">
        </el-table-column
        ><el-table-column prop="degree3" label="同意阶段数量" width="200">
        </el-table-column
        ><el-table-column prop="degree4" label="开始阶段数量" width="200">
        </el-table-column
        ><el-table-column prop="reasonType1" label="用户原因数量" width="200">
        </el-table-column
        ><el-table-column prop="reasonType2" label="主播原因数量" width="200">
        </el-table-column
        ><el-table-column prop="reasonType3" label="客户端原因数量" width="200">
        </el-table-column
        ><el-table-column prop="reasonType4" label="声网原因数量" width="200">
        </el-table-column
        ><el-table-column prop="reasonType5" label="网络原因数量" width="200">
        </el-table-column
        ><el-table-column prop="successRate1" label="通话成功率-总" width="200">
        </el-table-column
        ><el-table-column
          prop="successRate2"
          label="通话成功率-拨打阶段"
          width="200"
        >
        </el-table-column
        ><el-table-column
          prop="successRate3"
          label="通话成功率-技术通话成功率"
          width="200"
        >
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'

export default {
  data() {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      language: 'all',
      languageList: [],
      channel: 'total',
      channelsList: this.$store.state.channels,
      mode: "all",
    }
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  mounted() {},
  methods: {
    myChartBuild() {
      //   this.myChart.resize();
    },
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai() {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.chat_successRate_detail,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          page: this.page,
          country: this.country,
          mode: this.mode,
          channel: this.channel.join(','),
        },
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.download_chat_successRate_detail,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          country: this.country,
          language: this.language,
          platform: this.platform,
          channel: this.channel,
        },
      })
      this.$message.success('开始下载');
      this.login2 = false;
      download(res.data, '通话成功率-详细' + this.platformData[1]);
    },
    // 分页
    handleCurrentChange() {
      this.getDayChatDetai()
    },
    channelChange(currentVal) {
      const currentValLen = currentVal.length
      if (currentValLen !== 1) {
        if (
          currentVal[currentValLen - 1] === 'total' ||
          currentVal[currentValLen - 1] === 'all'
        ) {
          this.channel = [currentVal[currentValLen - 1]]
        }
      }

      if (currentValLen === 2) {
        if (currentVal[0] === 'total' || currentVal[0] === 'all') {
          this.channel = [currentVal[currentValLen - 1]]
        }
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }

  .custom-echart {
    width: 900px;
    height: 450px;
  }
}
</style>
